<template>
  <div class="grid-view">
    <div class="main-content finance-code-mapping">
      <cargo-left-right-resize
        :left-style="{flex:'none','max-width':'220px'}"
        :right-style="{'overflow': 'hidden'}"
        style="min-height:100%"
      >
        <template slot="left">
          <div style="min-width: 180px;width:100%;height:100%;padding:0px;">
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="leftGrid.gridOptions"
              :row-data="leftGrid.rowData"
              :column-defs="leftGrid.columnDefs"
              style="width:100%;height:100%;min-height: 500px;padding-left: 0px;"
              @gridReady="params=>{leftGrid.gridApi=params.api;leftGrid.gridApi.setFocusedCell(0, 'chineseName');}"
            />
          </div>
        </template>
        <template slot="right">
          <div class="section operations" style="flex:1;overflow:hidden;display:flex;flex-direction:column;height: 100%">
            <div class="filters" style="padding-left: 5px;">
              <span v-if="isEdit">
                <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
                <el-button type="primary" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
              </span>
              <span v-else>
                <el-input v-if="txtFilterVisible" v-model="txtFilter" style="width: 200px;margin: 0 5px 0 5px;" />
                <el-checkbox v-if="cbNewMappingVisible" v-model="cbNewMapping" style="margin: 0 10px 0 5px;">{{ $t('CargoMsg.Cargo_DisplayUnCodedRecordsOnly') }}</el-checkbox>
                <el-button type="primary" @click="queryCodeMapping">{{ $t('common.btn.query') }}</el-button>
                <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
                <el-button type="primary" :disabled="!cellSelected" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
                <el-button type="danger" :disabled="!cellSelected" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
                <el-button v-if="txtFilterVisible" type="primary" @click="downloadExcelTitleHandler">{{ $t('CargoMsg.Cargo_TemplateDownload') }}</el-button>
                <el-upload
                  v-if="txtFilterVisible"
                  :action="URL.sys.saveExcelFileUrl"
                  :headers="{sessionId: $store.getters.userInfo.sessionId}"
                  :data="{code: code, officeId: this.$store.getters.currentOfficeId }"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :on-success="onImportSucceeded"
                  :on-error="handleError"
                  :before-upload="handleBeforeUpload"
                  style="display: inline-block;margin: 0 5px"
                >
                  <el-button type="primary">{{ $t('CargoMsg.Cargo_ImportExcel') }}</el-button>
                </el-upload>
              </span>
            </div>
            <div class="section grid-wrapper">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-params.sync="gridParams"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                style="width:100%;height:100%;min-height: 500px;"
              />
            </div>
            <div class="pagination-wrapper">
              <cargo-pagination
                :total="pageConditions.total"
                :page.sync="pageConditions.pageNum"
                :limit.sync="pageConditions.pageSize"
                @pagination="queryCodeMapping"
              />
            </div>
          </div>
        </template>
      </cargo-left-right-resize>
    </div>

    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowDialogForm"
      :title="dialogTitle"
      inline-message
      width="405px"
    >
      <el-form
        ref="mappingForm"
        :model="mappingForm"
        label-width="120px"
        label-position="right"
      >
        <el-form-item :label="$t('CargoMsg.Cargo_Name')">
          <el-select v-if="code === SystemConstants.MAPPING_CHARGE_ITEM.code" v-model="mappingForm.sourceValue">
            <el-option
              v-for="item in lobTypeList"
              :key="item.code"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
          <el-select v-else-if="code === SystemConstants.MAPPING_ACCOUNT_CODE.code" v-model="mappingForm.sourceValue">
            <el-option
              v-for="item in officeList"
              :key="item.officeId"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="item.officeId"
            />
          </el-select>
          <el-select
            v-else-if="code === SystemConstants.MAPPING_RECEIPT_OR_PAYMENT.code"
            v-model="mappingForm.sourceValue"
          >
            <el-option
              v-for="item in payTypeList"
              :key="item.code"
              :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
          <el-input v-else v-model="mappingForm.sourceValue" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_TaxRevenueShortName')">
          <el-input v-model="mappingForm.targetValue" size="mini" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submit">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="isShowDialogForm=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--    获取未映射的发票抬头-->
    <invoice-title
      v-if="invoiceTitle.visible"
      :visible.sync="invoiceTitle.visible"
      @enter="enterHandler"
    />
  </div>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { codeMappingQueryFunc } from '@/api/act/preliminaryEstimate'
import { batchSaveMapping, delMapping, getMappingDetail, saveMapping } from '@/api/sysManage/baseConfig/mappingManage'
import InvoiceTitle from '@/views/cargo/v0/Clearing/components/SharedCenter/invoiceTitle'
import { cacheName, cache } from '@/utils/cacheManager'
import { AMOUNT_RECEIVE_TYPES } from '@/class/cargo/model/parameters/ClearingConstants'
import lodash from 'lodash'

export default {
  name: 'MappingManagement',
  components: { InvoiceTitle, cargoLeftRightResize },
  data() {
    return {
      cellSelected: false, // 是否选中行
      URL: URL,
      gridParams: {},
      gridApi: null,
      SystemConstants,
      invoiceTitle: {
        visible: false
      },
      gridOptions: {
        rowSelection: 'single',
        singleClickEdit: true,
        suppressContextMenu: true,
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        onRowClicked: (event) => { this.cellSelected = true; this.selectedItem = event.data }
      },
      rowData: [],
      pageConditions: {
        pageNum: 1,
        pageSize: 500,
        total: 0
      },
      leftGrid: {
        gridParams: {},
        gridApi: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          headerHeight: 0,
          onRowClicked: this.rowClickHandler
        },
        columnDefs: [
          {
            headerName: '',
            field: 'chineseName',
            width: 178
          }
        ],
        rowData: Array.from(SystemConstants.MAPPING_TYPES)
      },
      txtFilter: '',
      txtFilterVisible: false,
      cbNewMapping: false,
      cbNewMappingVisible: false,
      isEdit: false,
      code: 'SHARED_IT',
      officeMap: new Map(),
      lobTypeList: [],
      payTypeList: [],
      officeList: [],
      columnLabelFunc: null,
      selectorDialog: {
        visible: false,
        codeType: 0,
        codeMappingType: 0,
        existsMap: null,
        existsPartnerMap: null
      },
      map: new Map(),
      partnerMap: new Map(),
      cashflowItemDialog: {
        visible: false
      },
      selectedItem: null, // 表格选中项
      mappingForm: {
        uuid: '',
        type: '',
        condition1: '',
        sourceValue: '',
        targetValue: '',
        remarks: '',
        sendingPlatform: 'sharedCenter',
        sendingPlatformList: ['sharedCenter']
      },
      isShowDialogForm: false
    }
  },
  computed: {
    dialogTitle() {
      if (this.mappingForm.uuid) {
        return this.$t('CargoMsg.Cargo_MappingEditor')
      }
      return this.$t('CargoMsg.Cargo_NewMapping')
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'sourceValue',
          width: 180,
          editable: false,
          valueFormatter: params => {
            return this.columnLabelFunc ? this.columnLabelFunc(params.value) : params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Coding'),
          field: 'targetValue',
          width: 120,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }
      ]
    }
  },
  async created() {
    this.loadList()
    await cache.load(cacheName.OFFICE_LIST)
    this.officeList = cache.officeList
    for (const item of this.officeList) {
      this.officeMap.set(item.officeId, this.$store.getters.language === 'zh' ? item.chineseName : item.englishName)
    }
    this.lobTypeList = Array.from(SystemConstants.LOBS)
    this.payTypeList = lodash.cloneDeep(Array.from(AMOUNT_RECEIVE_TYPES))
    for (const data of this.payTypeList) {
      data.code = String(data.code)
    }
  },
  methods: {
    rowClickHandler(params) {
      this.code = params.data.code
      this.loadList()
    },
    loadList() {
      this.queryCodeMapping()
      this.refreshDataSource()
      this.refreshLabelFunc()
      if (this.gridOptions.api) {
        this.gridOptions.api.clearFocusedCell()
      }
      this.cellSelected = false
      this.selectedItem = null
    },
    queryCodeMapping() {
      const filterJson = {}
      filterJson.invoiceTitle = this.txtFilter
      filterJson.cbNewMapping = this.cbNewMapping
      filterJson.pageNum = this.pageConditions.pageNum
      filterJson.pageSize = this.pageConditions.pageSize
      filterJson.branchId = this.$store.getters.currentOfficeId
      filterJson.type = this.code
      filterJson.sendingPlatform = SystemConstants.SENDING_SHARED_CENTER.code
      const loading = getLoading4Cxt(this)
      codeMappingQueryFunc(filterJson).then(resp => {
        this.successHandler(resp)
      }).finally(() => loading.close())
      if (this.gridOptions.api) {
        this.gridOptions.api.clearFocusedCell()
      }
      this.cellSelected = false
      this.selectedItem = null
    },
    successHandler(resp) {
      if (resp.data) {
        const data = resp.data
        // this.pageConditions.pageSize = data.pageSize
        this.pageConditions.pageNum = data.pageNum
        this.pageConditions.total = Number(data.total)
        this.rowData = data.list
        if (this.gridOptions.api) {
          this.gridOptions.api.refreshCells({ force: true })
        }
      }
    },
    addHandler() {
      if (this.code === SystemConstants.MAPPING_INVOICE_TITLE.code) {
        this.invoiceTitle.visible = true
      } else {
        this.isShowDialogForm = true
        this.mappingForm = {}
      }
    },
    async editHandler() {
      if (this.code === SystemConstants.MAPPING_INVOICE_TITLE.code) {
        if (this.rowData && this.rowData.length > 0) {
          this.isEdit = true
          this.$nextTick(() => {
            this.gridOptions.api.setColumnDefs(this.getColumnDefs())
            this.gridOptions.api.redrawRows()
          })
        }
      } else {
        const cell = this.gridOptions.api.getFocusedCell()
        const nodes = this.gridOptions.api.rowModel.rowsToDisplay
        const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
        if (!selectedRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const mappingRes = await getMappingDetail(selectedRow.uuid)
        this.mappingForm = { ...mappingRes.data }
        // 显示编辑弹窗
        this.isShowDialogForm = true
      }
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteTheMapping'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        canCloseModule: true
      })
      const loading = getLoading4Cxt(this)
      await delMapping(currentRow.uuid).then(() => {
        this.removeSuccess(currentRow.uuid)
      }).finally(() => loading.close())
    },
    saveHandler() {
      this.loading = getLoading4Cxt(this)
      const list = this.rowData.filter(p => p.waitSave || !p.uuid)
      batchSaveMapping(list).then(async() => {
        this.loadList()
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.isEdit = false
        this.$nextTick(() => {
          this.gridOptions.api.setColumnDefs(this.getColumnDefs())
          this.gridOptions.api.redrawRows()
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    cancelHandler() {
      this.isEdit = false
      this.loadList()
    },
    async refreshDataSource() {
      const size = this.pageConditions.pageSize // 当前页数量
      const currentPage = (this.pageConditions.pageNum === 0) ? 1 : this.pageConditions.pageNum // 当前页
      this.rowData = []
      this.map = new Map()
      this.partnerMap = new Map()
      const list = []
      const nPage = size * currentPage
      const lPage = size * (currentPage - 1)
      if (list.length > 0) {
        for (let i; i <= list.length - 1; i++) {
          if (i < nPage && i >= lPage) {
            this.rowData.push(list[i])
          }
        }
      }
    },
    refreshLabelFunc() {
      this.txtFilter = ''
      this.txtFilterVisible = false
      this.cbNewMapping = false
      this.cbNewMappingVisible = false
      switch (this.code) {
        case SystemConstants.MAPPING_INVOICE_TITLE.code:
          this.txtFilterVisible = true
          this.columnLabelFunc = null
          break
        case SystemConstants.MAPPING_CHARGE_ITEM.code:
          this.columnLabelFunc = ColumnUtils.jobBussStateLabelFunc
          break
        case SystemConstants.MAPPING_ACCOUNT_CODE.code:
          this.columnLabelFunc = this.officeLabelFunc
          break
        case SystemConstants.MAPPING_RECEIPT_OR_PAYMENT.code:
          this.columnLabelFunc = ColumnUtils.receiptPaymentTypeLabelFunc
          break
        default:
          break
      }
    },
    officeLabelFunc(value) {
      return this.officeMap.get(Number(value))
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitSave = true
      }
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    downloadExcelHandler() {
      ExportUtils.downloadTemplateFile('ImportEnCode.xls', 'enCode')
    },
    onImportSucceeded(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        const r = response.data.toString().indexOf('ok') === -1
        let text = ''
        if (!r) {
          const textData = response.data.toString().split('_')
          text = this.$t('Message.ImportSuccessful1') + ':' + textData[1] + this.$t('Message.ImportSuccessful2')
        } else if (response.data === 'dataRepetition') {
          text = this.$t('CargoMsg.Cargo_DataRepetition')
        } else if (response.data === 'noData') {
          text = this.$t('CargoMsg.Cargo_NoData')
        } else if (response.data === 'errorExcel') {
          text = this.$t('CargoMsg.Cargo_ErrorExcel')
        } else {
          text = this.$t('CargoMsg.Cargo_ImportException')
        }
        this.$confirm(text, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          dangerouslyUseHTMLString: true,
          type: r ? 'warning' : 'success'
        }).then(() => {
          this.loadList()
        }).catch(() => {})
      }
    },
    handleBeforeUpload(file) {
      this.loading = getLoading4Cxt(this)
    },
    handleError(err) {
      this.loading.close()
      console.log(err)
    },
    getColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'sourceValue',
          suppressMenu: true,
          width: 180,
          lockVisible: true,
          editable: false,
          valueFormatter: params => {
            return this.columnLabelFunc ? this.columnLabelFunc(params.value) : params.value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Coding'),
          field: 'targetValue',
          suppressMenu: true,
          width: 120,
          editable: this.isEdit,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 值变化事件
          onCellValueChanged: params => {
            this.onCellChange(params)
          }
        }
      ]
    },
    async submit() {
      this.loading = getLoading4Cxt(this)
      this.mappingForm.officeId = this.$store.getters.currentOfficeId
      this.mappingForm.sendingPlatform = 'sharedCenter'
      this.mappingForm.type = this.code
      saveMapping(this.mappingForm, this.mappingForm.uuid).then(async() => {
        this.isShowDialogForm = false
        await this.loadList()
      }).finally(() => {
        this.loading.close()
      })
    },
    downloadExcelTitleHandler() {
      ExportUtils.downloadTemplateFile('ImportTitleCode.xls', 'enCode')
    },
    enterHandler(mapping) {
      this.rowData = [...this.rowData, ... mapping]
      this.isEdit = true
      this.$nextTick(() => {
        this.gridOptions.api.setColumnDefs(this.getColumnDefs())
        this.gridOptions.api.redrawRows()
      })
      this.gridOptions.api.refreshCells({ force: true })
      this.cashflowItemDialog.visible = false
    }
  }
}
</script>

<style scoped>

</style>
